import React from 'react';
import { Link } from 'react-router-dom';
import './secondPageStyle.scss';
// import LogoIcon from '../../assets/images/logoProject.png';
import backIcon from '../../assets/icons/arrow-left.svg';
// import AboutUs from '../shrineInformation/ShrineInformation';
// import PilgrimageLetter from '../pilgrimageLetter/PilgrimageLetter';
// import ShrinePlane from '../shrinePlan/ShrinePlane';
import EndLayoutStyle from '../endLayout/EndLayout';
import Border from '../../assets/images/Border.svg';


function headerSection(){
    return(
        // <div className='second-base background-pattern'>
        //     <div className='Header-container-secondPage'>
        //         <div className='header-menu-secondPage'>
        //             {/* <img src={LogoIcon} className="logo-icon" alt="" /> */}
        //             <img src={Border} className="border-icon" alt="" />
        //            <Link to={'*'} className='back-icon'> <img src={backIcon} alt="the back icon" /> </Link>
        //         </div>
        //     </div>
            
        //     {/* <div className='body-secondPage'>
        //          بدنه با توجه به نوع باتن
        //     </div> */}
        //     <div className='footer-seconPage'>
        //        <EndLayoutStyle></EndLayoutStyle>
        //     </div>
        //  </div>  
        <></> 
    )
};

export default headerSection;